import { useEffect, useState } from 'react';
import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';

import { ILead } from "../../models/Lead";
import { ScheduledCollectionSlot } from "../../models/Vehicle";
import useSingleSetting from "../../data/useSingleSetting";
import { getLeadLocation } from "../../utils/getLeadLocation";


// 0,0 (never geocoded) is treated as "no location" so the marker is hidden.
function getLeadMapMarker(lead: ILead): { lat: number; lng: number; postcode: string } | null {
  const location = getLeadLocation(lead);
  const lat = location?.latitude;
  const lng = location?.longitude;

  if (!lat || !lng) return null;

  return { lat, lng, postcode: location?.postcode ?? "" };
}


export default function CalendarDayMap({ leads, selectedLead }: { leads: ILead[], selectedLead: ILead | undefined }) {
  const [icon, setIcon] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { singleSetting: longSetting } = useSingleSetting("MapCentre:Long");
  const { singleSetting: latSetting } = useSingleSetting("MapCentre:Lat");

  const [mapCentreLong, setMapCentreLong] = useState<number>(51.049758);
  const [mapCentreLat, setMapCentreLat] = useState<number>(-2.407408);
  const [coordinatesLoading, setCoordinatesLoading] = useState(true);
  // const myCustomColour = '#138200';

  //   const markerHtmlStyles = `
  //     background-color: ${myCustomColour};
  //     width: 2.5rem;
  //     height: 2.5rem;
  //     display: block;
  //     left: -1rem;
  //     top: -1rem;
  //     position: relative;
  //     border-radius: 3rem 3rem 0;
  //     transform: rotate(45deg);
  //     border: 1px solid #FFFFFF;`;

  const customIcon = L.divIcon({
    className: "my-custom-pin",
    iconSize: [32, 32],
    iconAnchor: [18, 36],
    popupAnchor: [0, -36],
    html: `<span class="custom-pin"/>` //style="${markerHtmlStyles}"
  });

  useEffect(() => {
    setIcon(customIcon);
    setIsLoading(false);
  }, [leads])

  useEffect(() => {
    if (longSetting.isLoading || latSetting.isLoading) return;
    // A missing/404'd setting resolves as { data: null }, so guard the inner payload too.
    if (longSetting.data?.data?.value == null) return;
    if (latSetting.data?.data?.value == null) return;

    setMapCentreLong(+longSetting.data.data.value);
    setMapCentreLat(+latSetting.data.data.value);

    setCoordinatesLoading(false);

  }, [longSetting.isLoading, latSetting.isLoading])

  return (
    <div className="my-6 h-[45vh] z-10 w-full">
      {(!isLoading && !coordinatesLoading) &&
        <MapContainer className="h-full z-10" center={[mapCentreLong, mapCentreLat]} zoom={8} scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            referrerPolicy="origin"
          />
          {
            leads.map((lead, index) => {
              const marker = getLeadMapMarker(lead);
              if (!marker) return null;

              return (
                <Marker key={index} position={[marker.lat, marker.lng]}>
                  <Popup className="w-[20rem]">
                    <div>
                      {lead.vehicle?.vrm ? `${lead.vehicle.vrm}, ${marker.postcode} - ${ScheduledCollectionSlot[lead.vehicle.scheduledCollectionSlot]} ` : "No VRM"}
                    </div>
                  </Popup>
                </Marker>
              );
            })
          }
          {
            (() => {
              if (!selectedLead) return null;
              const marker = getLeadMapMarker(selectedLead);
              if (!marker) return null;

              return (
                <Marker key={selectedLead.id} position={[marker.lat, marker.lng]} icon={icon}>
                  <Popup className="w-[20rem]">
                    <div>
                      {selectedLead.vehicle?.vrm ? `${selectedLead.vehicle.vrm}, ${marker.postcode} - ${ScheduledCollectionSlot[selectedLead.vehicle.scheduledCollectionSlot]} ` : "No VRM"}
                    </div>
                  </Popup>
                </Marker>
              );
            })()
          }
          {/* <Marker position={[51.505, -0.09]}>
          <Popup className="w-[20rem]">
            
          </Popup>
        </Marker> */}
        </MapContainer>
      }
    </div>
  );
}
